import { Dispatch } from "redux";
import { setVerificationTransactionsSearchResultsLoading, setVerificationTransactionsSearchResults } from "@redux/actions/verification-transactions-actions";
import { getVerificationTransactionsRequest } from "@requests/reports/get-verification-transactions";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { formatVerificationTransactionsResponse } from "@formatters/verification-transactions-response/verification-transactions-response-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { SERVER_DATE_TIME_FORMAT } from "@constants/date-formats";
import format from "date-fns/format";
import { generateQueryParameters } from "@utils/query-parameter-util";

export const getVerificationTransactionsSearchResultsReduxRequest = (dispatch: Dispatch, signal: AbortSignal) => async (
    credentials: string,
    serviceOfferingIds: Array<string>,
    assertionIds: Array<string>,
    claimStatuses: Array<string>,
    companyIds: Array<string>,
    relyingPartyIds: Array<string>,
    apiKeys: Array<string>,
    appIds: Array<string>,
    transactionId: string,
    policyDecisions: Array<string>,
    sessionKey: string,
    workflowIds: Array<string>,
    startDate: Date,
    endDate: Date,
    axnRelyingParties: Array<AxnRelyingParty>,
    countries: Array<string>
) => {
    dispatch(setVerificationTransactionsSearchResultsLoading(true));

    signal.addEventListener("abort", () => {
        dispatch(setVerificationTransactionsSearchResultsLoading(false));
    });

    const queryParameters = generateQueryParameters({
        serviceOfferingIDs: serviceOfferingIds,
        assertionIDs: assertionIds,
        claimStatuses: claimStatuses,
        companyIDs: companyIds,
        relyingPartyIDs: relyingPartyIds,
        apiKeys: apiKeys,
        appIDs: appIds,
        policyDecisions: policyDecisions,
        workflowIDs: workflowIds,
        credentials: credentials,
        startDate: format(startDate, SERVER_DATE_TIME_FORMAT),
        endDate: format(endDate, SERVER_DATE_TIME_FORMAT),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: countries,
        dateFormat: SERVER_DATE_TIME_FORMAT
    });

    if (transactionId) {
        const asis = transactionId.split(",").map(asi => `%${asi}%`).join(",");
        queryParameters.push({ parameter: "asisLike", value: asis });
    }
    if (sessionKey) {
        const sessionKeys = sessionKey.split(",").map(sessionKeyItem => `%${sessionKeyItem}%`).join(",");
        queryParameters.push({ parameter: "sessionKeysLike", value: sessionKeys });
    }

    let verificationTransactionsData = null;
    const verificationTransactions = await getVerificationTransactionsRequest(queryParameters, signal);

    if (verificationTransactions.data) {
        verificationTransactionsData = formatVerificationTransactionsResponse(verificationTransactions.data, axnRelyingParties);
    } else if (verificationTransactions.error) {
        logAndDisplayErrorModal(
            dispatch,
            verificationTransactions.error,
            resources.requests.getVerificationTransactions.error.title,
            resources.requests.getVerificationTransactions.error.message
        );
    }

    dispatch(setVerificationTransactionsSearchResults(verificationTransactionsData));
};